import React from "react";
import './data-card-toolbar.scss';

export interface IDataCardToolbarProps {
	content?: React.ReactNode
}

const DataCard: React.FC<IDataCardToolbarProps> = ({
	                                                   content
                                                   }) => {
	
	return (
		<div className='data-card-toolbar'>
			{content}
		</div>
	);
}

export default DataCard;